import DOMPurify from "dompurify";

// Outline rows -> HTML with real heading tags. Mirrors the backend's
// `_outline_html` (ai_writer_v2_api.py) so every outline export matches.
function esc(s) {
  return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function outlineHtmlFromRows(rows) {
  return (rows || [])
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((r) => {
      if (r.kind === "h2") return `<h2>${esc(r.text)}</h2>`;
      if (r.kind === "h3") return `<h3>${esc(r.text)}</h3>`;
      if (r.kind === "intro") return "<h2>Introduction</h2>";
      if (r.kind === "visual") {
        // Key takeaways is a real article section, so it belongs in the outline as
        // a heading; other visuals are in-section elements and stay placeholders.
        if (r.visual_type === "key_highlights") return "<h2>Key takeaways</h2>";
        return `<p><em>[${esc(r.visual_type || "visual")}]</em></p>`;
      }
      return "";
    })
    .filter(Boolean)
    .join("\n");
}

// Inverse of outlineHtmlFromRows: pull <h2>/<h3> out of pasted HTML so sub-headings
// can be added in bulk. Mirrors the old AI Writer's "Add as HTML" tab -- sanitize to
// h2/h3, then take every heading node in document order.
export function parseHeadingsHtml(html) {
  const clean = DOMPurify.sanitize(html || "", { ALLOWED_TAGS: ["h2", "h3"], ALLOWED_ATTR: [] });
  const doc = new DOMParser().parseFromString(`<div>${clean}</div>`, "text/html");
  return Array.from(doc.body.querySelectorAll("h2, h3"))
    .map((h) => ({ kind: h.tagName.toLowerCase(), text: (h.textContent || "").trim() }))
    .filter((h) => h.text);
}
